import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from 'react-oidc-context';
import { useOfficeTheme } from '../lib/useOfficeTheme';
import { useOidcMessageHandler } from '../hooks/useOidcMessageHandler';
import AuthNavigator from './auth/AuthNavigator';
import { McpSessionProvider } from './McpSessionProvider';
import Main from './pages/Main';
import OAuthCallback from './oauth/OAuthCallback';
export default function App() {
    const { isAuthenticated } = useAuth();
    const theme = useOfficeTheme();
    // Handle OIDC messages from auth popup
    useOidcMessageHandler();
    // Check if this is the OAuth callback route
    const isOAuthCallback = window.location.pathname === '/oauth/callback' ||
        window.location.search.includes('code=') ||
        window.location.search.includes('error=');
    // Handle OAuth callback route
    if (isOAuthCallback) {
        return (_jsx("div", { className: `h-full ${theme.isDark ? 'dark' : ''}`, children: _jsx("div", { className: "h-full bg-background text-foreground", children: _jsx(OAuthCallback, {}) }) }));
    }
    return (_jsx("div", { className: `h-full ${theme.isDark ? 'dark' : ''}`, children: _jsx("div", { className: "h-full bg-background text-foreground", children: isAuthenticated ? (_jsx(McpSessionProvider, { children: _jsx(Main, {}) })) : (_jsx(AuthNavigator, {})) }) }));
}
